let scrollTimer = 0;

/** Scroll the first form error banner into view. Safe to call before React paints it. */
export function scrollToFormError() {
  window.clearTimeout(scrollTimer);
  scrollTimer = window.setTimeout(() => {
    document
      .querySelector<HTMLElement>("[data-form-error]")
      ?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, 50);
}
